module.exports = __webpack_public_path__ + "static/img/travel.c30e7b8d.svg";